<template>
  <div class="brand-header">
    <div class="brand-container">
      <div class="brand-header__content">
        <div class="brand-header__logo">
          <a
            href="https://goldnet.market/"
            class="brand-header__logo-link"
          ></a>
        </div>
        <div class="brand-header__cart">
          <router-link
            to="/product-cart"
            class="brand-header__cart-link"
          >
            <div class="brand-header__cart-icon">
              <span
                v-if="totalAmount > 0"
                :class="{ 'over-99': totalAmount > 99 }"
                class="cabinet__quantity-in-the-basket"
              >
                {{ totalAmount > 99 ? '99+' : totalAmount }}
              </span>
            </div>
            <div class="brand-header__cart-text">Корзина</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderBrand',

  computed: {
    ...mapGetters({
      totalAmount: 'totalAmountCartPublic',
    }),
  }
}
</script>

<style>
.brand-header__cart-icon {
  position: relative;
}
</style>